import { Pipe, PipeTransform } from '@angular/core';

import { ContentChannel } from 'app/providers/storage-api/content-channel.service';

@Pipe({
  name: 'contentChannelLabel',
  standalone: true,
})
export class ContentChannelLabelPipe implements PipeTransform {
  transform(value: ContentChannel, lang: string): string {
    switch (lang) {
      case 'fr':
        return value.properties.label_fr;
      case 'de':
        return value.properties.label_de;
      case 'it':
        return value.properties.label_it;
      case 'ja':
        return value.properties.label_ja;
      case 'ko':
        return value.properties.label_ko;
      case 'pt':
        return value.properties.label_pt;
      case 'es':
        return value.properties.label_es;
      case 'bn':
        return value.properties.label_bn;
      case 'en':
      default:
        return value.label;
    }
  }
}
